import { Component, OnInit, Inject } from '@angular/core';
import { IMioRegion, MioService, IMioLivingComplex, IMioSpot, IMioLicense } from '../mio.service';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-mio-access-dialog',
  templateUrl: './mio-access-dialog.component.html',
  styleUrls: ['./mio-access-dialog.component.scss']
})
export class MioAccessDialogComponent implements OnInit {

  regions: IMioRegion[] = [];
  cities: IMioRegion[] = [];
  livingComplexes: IMioLivingComplex[] = [];
  licenses: IMioLicense[] = [];
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    monthLabels: { 1: 'Янв', 2: 'Фев', 3: 'Мар', 4: 'Апр', 5: 'Май', 6: 'Июн', 7: 'Июл', 8: 'Авг', 9: 'Сен', 10: 'Окт', 11: 'Ноя', 12: 'Дек' },
    dayLabels: { su: 'Вс', mo: 'Пн', tu: 'Вт', we: 'Ср', th: 'Чт', fr: 'Пт', sa: 'Сб' },
    minYear: 2000,
    maxYear: 2030,
    showTodayBtn: false,
    showClearDateBtn: false,
    alignSelectorRight: true,
    openSelectorOnInputClick: true,
    height: '34px',
    width: '132px',
    inline: false
  };

  constructor(
    public dialogRef: MatDialogRef<MioAccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: MioService,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.regions = this.data.regions;
    this.livingComplexes = this.data.livingComplexes;
    this.licenses = this.data.licenses;
  }

  citiesLoader: boolean = false;
  selectedRegionId: number;
  selectRegion(id: number) {
    this.selectedRegionId = id;
    this.selectedCityId = null;
    this.selectedLivingComplexes = [];
    this.selectedSpotsEx = [];
    this.citiesLoader = true;
    this.service.getCities(id).subscribe(res => {
      this.cities = res;
      this.citiesLoader = false;
    });
  }

  selectedLivingComplexes: IMioLivingComplex[] = [];
  selectedCityId: number;
  selectCity(id: number) {
    this.selectedSpotsEx = [];
    this.selectedCityId = id;
    this.selectedLivingComplexes = this.livingComplexes.filter(liv => liv.city.id === id);
  }

  selectedSpotsEx: IMioSpotEx[] = [];
  selectedLgId: number;
  selectLg(id: number) {
    this.selectedLgId = id;
    let selectedSpots: IMioSpot[] = this.selectedLivingComplexes.find(f => f.id === id).spots;
    this.selectedSpotsEx = this.updateSpots(selectedSpots);
  }

  updateSpots(spots: IMioSpot[]) {
    let res: IMioSpotEx[] = [];
    res = spots.map(spot => {
      let fSpot = this.licenses.find(f => f.buildingId === spot.id);
      let endDate = (typeof fSpot == 'undefined') ? null : new Date(fSpot.endDate);
      return {
        id: spot.id,
        isSimpleStagesInput: spot.isSimpleStagesInput,
        number: spot.number,
        startDate: (typeof fSpot === 'undefined') ? null : fSpot.startDate,
        endDate: (typeof fSpot === 'undefined') ? null : { date: { year: endDate.getFullYear(), month: endDate.getMonth() + 1, day: endDate.getDate() } },
      }
    });
    return res;
  }

  extend(id: number) {
    if (confirm('Вы точно уверены продлить?')) {
      this.prepareObj(this.selectedSpotsEx);
    } else {
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  btnDisable: boolean;
  onDateChanged($date) {
    let curDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
    let date = new Date($date.jsdate).getTime();
    if (curDate > date) {
      alert('Нельзя выбирать дату меньше текущего дня');
      this.btnDisable = true;
    } else {
      this.btnDisable = false;
    }
  }

  res: IMioLicense[] = [];
  prepareObj(spots: IMioSpotEx[]) {
    spots.forEach(spot => {
      spot.startDate = moment().format('YYYY-MM-DD')
      spot.endDate = (spot.endDate.hasOwnProperty('jsdate')) ? moment(spot.endDate["jsdate"]).format('YYYY-MM-DD') : null;
    });
    spots.forEach(spot => {
      this.res.push({
        buildingId: spot.id,
        startDate: spot.startDate,
        endDate: spot.endDate
      });
    });
    this.licenses.forEach(lic => {
      let ind = this.res.findIndex(f => f.buildingId == lic.buildingId);
      if (ind === -1) {
        this.res.push({
          buildingId: lic.buildingId,
          startDate: lic.startDate,
          endDate: lic.endDate
        });
      }
    });
    this.sendLicense(this.res);
  }

  sendLicense(lic: IMioLicense[]) {
    this.service.setLicense(1, '002', JSON.stringify(lic)).subscribe(res => {
      this.snackBar.open('Доступ успешно продлен!', '', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snackbar-succes']
      });
    })
  }

}


interface IMioSpotEx extends IMioSpot {
  endDate: any;
  startDate: any;
}
